export enum formFieldsEnum {
	leaveDate = 'leaveDate',
	dateFinAssurance = 'dateFinAssurance',
	dateDebutAssurance = 'dateDebutAssurance',
	phone = 'phone',
	preChoicesOption = 'preChoicesOption',
	preDateChoices = 'preDateChoices',
	choicesOption = 'choicesOption',
	dateChoices = 'dateChoices',
	leaveReason = 'leaveReason',
	comment = 'comment',
	standaloneStatus = 'standaloneStatus',
	attachment = 'attachment',
	allowYFCampus = 'allowYFCampus'
}
